<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light"
    id="ftco-navbar"
  >
    <div class="container">
      <a class="navbar-brand" href="/"
        >Kigali Car Rental <span>Self Drive</span></a
      >
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#ftco-nav"
        aria-controls="ftco-nav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="oi oi-menu"></span> Menu
      </button>

      <div class="collapse navbar-collapse" id="ftco-nav">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item active"><a href="/" class="nav-link">Home</a></li>
          <li class="nav-item"><a href="/about" class="nav-link">About</a></li>
          <li class="nav-item">
            <a href="/services" class="nav-link">Services</a>
          </li>
          <li class="nav-item">
            <a href="/pricing" class="nav-link">Pricing</a>
          </li>
          <li class="nav-item"><a href="/cars" class="nav-link">Cars</a></li>
          <li class="nav-item">
            <a href="/blog" class="nav-link">Blog</a>
          </li>
          <li class="nav-item">
            <a href="/contact" class="nav-link">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- END nav -->

  <div
    class="hero-wrap ftco-degree-bg"
    style="background-image: url('images/carhire29.jpeg')"
    data-stellar-background-ratio="0.5"
  >
    <div class="overlay"></div>
    <div class="container">
      <div
        class="row no-gutters slider-text justify-content-start align-items-center justify-content-center"
      >
        <div class="col-lg-8">
          <div class="text w-100 text-center mb-md-5 pb-md-5">
            <h1 class="mb-4">Fast &amp; Easy Way To Rent A Car</h1>
            <p style="font-size: 18px">
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts
            </p>
            <a
              href="#"
              class="icon-wrap popup-vimeo d-flex align-items-center mt-4 justify-content-center"
            >
              <div
                class="icon d-flex align-items-center justify-content-center"
              >
                <span class="ion-ios-play"></span>
              </div>
              <div class="heading-title ml-5">
                <span>Easy steps for renting a car</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="ftco-section ftco-no-pt bg-light">
    <div class="container">
      <div class="row no-gutters">
        <div class="col-md-12 featured-top">
          <div class="row no-gutters">
            <div class="col-md-4 d-flex align-items-center">
              <form action="#" class="request-form bg-primary">
                <h2>Make your trip</h2>
                <div class="form-group">
                  <label for="" class="label">Pick-up location</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="City, Airport, Station, etc"
                  />
                </div>
                <div class="form-group">
                  <label for="" class="label">Drop-off location</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="City, Airport, Station, etc"
                  />
                </div>
                <div class="d-flex">
                  <div class="form-group mr-2">
                    <label for="" class="label">Pick-up date</label>
                    <input
                      type="text"
                      class="form-control"
                      id="book_pick_date"
                      placeholder="Date"
                    />
                  </div>
                  <div class="form-group ml-2">
                    <label for="" class="label">Drop-off date</label>
                    <input
                      type="text"
                      class="form-control"
                      id="book_off_date"
                      placeholder="Date"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="" class="label">Pick-up time</label>
                  <input
                    type="text"
                    class="form-control"
                    id="time_pick"
                    placeholder="Time"
                  />
                </div>
                <div class="form-group">
                  <button type="button" class="btn btn-secondary py-3 px-4">
                    Rent a Car Now
                  </button>
                </div>
              </form>
            </div>
            <div class="col-md-8 d-flex align-items-center">
              <div class="services-wrap rounded-right w-100">
                <h3 class="heading-section mb-4">
                  Better Way to Rent Your Perfect Cars
                </h3>
                <div class="row d-flex mb-4">
                  <div class="col-md-4 d-flex align-self-stretch">
                    <div class="services w-100 text-center">
                      <div
                        class="icon d-flex align-items-center justify-content-center"
                      >
                        <span class="flaticon-route"></span>
                      </div>
                      <div class="text w-100">
                        <h3 class="heading mb-2">
                          Choose Your Pickup Location
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex align-self-stretch">
                    <div class="services w-100 text-center">
                      <div
                        class="icon d-flex align-items-center justify-content-center"
                      >
                        <span class="flaticon-handshake"></span>
                      </div>
                      <div class="text w-100">
                        <h3 class="heading mb-2">Select the Best Deal</h3>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 d-flex align-self-stretch">
                    <div class="services w-100 text-center">
                      <div
                        class="icon d-flex align-items-center justify-content-center"
                      >
                        <span class="flaticon-rent"></span>
                      </div>
                      <div class="text w-100">
                        <h3 class="heading mb-2">Reserve Your Rental Car</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <p>
                  <a href="#" class="btn btn-primary py-3 px-4"
                    >Reserve Your Perfect Car</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="
                background-image: url(images/4x4-car-hire-land-cruiser.jpeg);
              "
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">Safar Car</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota Land Cruiser</span>
                <p class="price ml-auto">$150 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/car-2.jpg)"
            ></div>
            <div class="text">
              <h2 class="mb-0"><a href="#">Range Rover</a></h2>
              <div class="d-flex mb-3">
                <span class="cat">Subaru</span>
                <p class="price ml-auto">$100 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/rav4-s-2.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">RAVA 4</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota RAVA 4 2018</span>
                <p class="price ml-auto">$80 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/rava4-new.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">RAVA 4</a>
              </h2>
              <div class="d-flex mb-3">
                <!-- <span class="cat">Cheverolet</span> -->
                <p class="price ml-auto">$60 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="
                background-image: url(images/Toyota-rav4-Car-hire-Rwanda.png);
              "
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">RAVA 4</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota RAVA 4 2014</span>
                <p class="price ml-auto">$60 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/toyota-hilux-cab-4wd-4.jpg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">Toyota Hilux</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota Hilux 4WD</span>
                <p class="price ml-auto">$100 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/coastel.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">Coastel</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota Coastel</span>
                <p class="price ml-auto">$200 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/car-8.jpg)"
            ></div>
            <div class="text">
              <h2 class="mb-0"><a href="#">Range Rover</a></h2>
              <div class="d-flex mb-3">
                <span class="cat">Subaru</span>
                <p class="price ml-auto">$200 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="
                background-image: url(images/z2qDr75krrC3UMlOJAcdt5MIcDOI8skgS77G0YiL.jpg);
              "
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">HYNDAI 2016</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Santa fe 2016 Sports Model</span>
                <p class="price ml-auto">$70 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/carhire26.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">TXL</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota Land cruiser TXL</span>
                <p class="price ml-auto">$100 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/carhire24.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0"><a href="#">SONATA</a></h2>
              <div class="d-flex mb-3">
                <span class="cat">HYUNDAI Sonata</span>
                <p class="price ml-auto">$50 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="car-wrap rounded">
            <div
              class="img rounded d-flex align-items-end"
              style="background-image: url(images/carhire38.jpeg)"
            ></div>
            <div class="text">
              <h2 class="mb-0">
                <a href="#">V8</a>
              </h2>
              <div class="d-flex mb-3">
                <span class="cat">Toyota Land cruiser V8</span>
                <p class="price ml-auto">$100 <span>/day</span></p>
              </div>
              <p class="d-flex mb-0 d-block">
                <a href="#" class="btn btn-primary py-2 mr-1">Book now</a>
                <a href="#" class="btn btn-secondary py-2 ml-1">Details</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <div class="block-27">
            <ul>
              <li><a href="#">&lt;</a></li>
              <li class="active"><span>1</span></li>
              <li><a href="#">2</a></li>
              <li><a href="#">3</a></li>
              <li><a href="#">4</a></li>
              <li><a href="#">5</a></li>
              <li><a href="#">&gt;</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section ftco-about">
    <div class="container">
      <div class="row no-gutters">
        <div
          class="col-md-6 p-md-5 img img-2 d-flex justify-content-center align-items-center video-background"
        >
          <video autoplay muted loop playsinline class="background-video">
            <source src="images/ma_video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div class="col-md-6 wrap-about">
          <div class="heading-section heading-section-white pl-md-5">
            <span class="subheading">About us</span>
            <h3 class="mb-4">Welcome to Kigali Car Rental Self Drive</h3>

            <p>
              A small river named Duden flows by their place and supplies it
              with the necessary regelialia. It is a paradisematic country, in
              which roasted parts of sentences fly into your mouth.
            </p>
            <p>
              On her way she met a copy. The copy warned the Little Blind Text,
              that where it came from it would have been rewritten a thousand
              times and everything that was left from its origin would be the
              word "and" and the Little Blind Text should turn around and return
              to its own, safe country. A small river named Duden flows by their
              place and supplies it with the necessary regelialia. It is a
              paradisematic country, in which roasted parts of sentences fly
              into your mouth.
            </p>
            <p>
              <a href="#" class="btn btn-primary py-3 px-4">Search Car</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 text-center heading-section">
          <span class="subheading">Services</span>
          <h2 class="mb-3">Our Current Services</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="services services-2 w-100 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <span class="flaticon-wedding-car"></span>
            </div>
            <div class="text w-100">
              <h3 class="heading mb-2">Wedding Ceremony</h3>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="services services-2 w-100 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <span class="flaticon-transportation"></span>
            </div>
            <div class="text w-100">
              <h3 class="heading mb-2">City Transfer</h3>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="services services-2 w-100 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <span class="flaticon-car"></span>
            </div>
            <div class="text w-100">
              <h3 class="heading mb-2">Airport Transfer</h3>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="services services-2 w-100 text-center">
            <div class="icon d-flex align-items-center justify-content-center">
              <span class="flaticon-transportation"></span>
            </div>
            <div class="text w-100">
              <h3 class="heading mb-2">Whole City Tour</h3>
              <p>
                A small river named Duden flows by their place and supplies it
                with the necessary regelialia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section ftco-intro video-background1">
    <div class="overlay"></div>
    <video autoplay muted loop playsinline class="background-video1">
      <source src="images/driver.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div class="container">
      <div class="row justify-content-end">
        <div class="col-md-6 heading-section heading-section-white">
          <h2 class="mb-3">Do You Want To Earn With Us? So Don't Be Late.</h2>
          <a href="#" class="btn btn-primary btn-lg">Become A Driver</a>
        </div>
      </div>
    </div>
  </section>
  <section class="ftco-section testimony-section bg-light">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 text-center heading-section">
          <span class="subheading">Testimonial</span>
          <h2 class="mb-3">Happy Clients</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="carousel-testimony">
            <div class="item">
              <div class="testimony-wrap rounded text-center py-4 pb-5">
                <div
                  class="user-img mb-2"
                  style="background-image: url(images/person_1.jpg)"
                ></div>
                <div class="text pt-4">
                  <p class="mb-4">
                    Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.
                  </p>
                  <p class="name">Roger Scott</p>
                  <span class="position">Marketing Manager</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="carousel-testimony">
            <div class="item">
              <div class="testimony-wrap rounded text-center py-4 pb-5">
                <div
                  class="user-img mb-2"
                  style="background-image: url(images/person_1.jpg)"
                ></div>
                <div class="text pt-4">
                  <p class="mb-4">
                    Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.
                  </p>
                  <p class="name">Roger Scott</p>
                  <span class="position">Marketing Manager</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="carousel-testimony">
            <div class="item">
              <div class="testimony-wrap rounded text-center py-4 pb-5">
                <div
                  class="user-img mb-2"
                  style="background-image: url(images/person_1.jpg)"
                ></div>
                <div class="text pt-4">
                  <p class="mb-4">
                    Far far away, behind the word mountains, far from the
                    countries Vokalia and Consonantia, there live the blind
                    texts.
                  </p>
                  <p class="name">Roger Scott</p>
                  <span class="position">Marketing Manager</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="ftco-section">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-7 heading-section text-center">
          <span class="subheading">Blog</span>
          <h2>Recent Blog</h2>
        </div>
      </div>
      <div class="row d-flex">
        <div class="col-md-4 d-flex">
          <div class="blog-entry justify-content-end">
            <a
              href="#"
              class="block-20"
              style="background-image: url('images/image_1.jpg')"
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">Oct. 29, 2019</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#">Why Lead Generation is Key for Business Growth</a>
              </h3>
              <p><a href="#" class="btn btn-primary">Read more</a></p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="blog-entry justify-content-end">
            <a
              href="#"
              class="block-20"
              style="background-image: url('images/image_2.jpg')"
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">Oct. 29, 2019</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#">Why Lead Generation is Key for Business Growth</a>
              </h3>
              <p><a href="#" class="btn btn-primary">Read more</a></p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="blog-entry">
            <a
              href="#"
              class="block-20"
              style="background-image: url('images/image_3.jpg')"
            >
            </a>
            <div class="text pt-4">
              <div class="meta mb-3">
                <div><a href="#">Oct. 29, 2019</a></div>
                <div><a href="#">Admin</a></div>
                <div>
                  <a href="#" class="meta-chat"
                    ><span class="icon-chat"></span> 3</a
                  >
                </div>
              </div>
              <h3 class="heading mt-2">
                <a href="#">Why Lead Generation is Key for Business Growth</a>
              </h3>
              <p><a href="#" class="btn btn-primary">Read more</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="ftco-counter ftco-section img bg-light" id="section-counter">
    <div class="overlay"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-3 justify-content-center counter-wrap">
          <div class="block-18">
            <div class="text text-border d-flex align-items-center">
              <strong class="number" data-number="60">7</strong>
              <span>Year <br />Experienced</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 justify-content-center counter-wrap">
          <div class="block-18">
            <div class="text text-border d-flex align-items-center">
              <strong class="number" data-number="1090">> 20</strong>
              <span>Total <br />Cars</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 justify-content-center counter-wrap">
          <div class="block-18">
            <div class="text text-border d-flex align-items-center">
              <strong class="number" data-number="2590">> 200</strong>
              <span>Happy <br />Customers</span>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-lg-3 justify-content-center counter-wrap">
          <div class="block-18">
            <div class="text d-flex align-items-center">
              <strong class="number" data-number="67">2</strong>
              <span>Total <br />Branches</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <footer class="ftco-footer ftco-bg-dark ftco-section">
    <div class="container">
      <div class="row mb-5">
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">
              <a href="#" class="logo"
                >Kigali Car Rental <span>Self Drive</span></a
              >
            </h2>
            <p>
              Far far away, behind the word mountains, far from the countries
              Vokalia and Consonantia, there live the blind texts.
            </p>
            <ul
              class="ftco-footer-social list-unstyled float-md-left float-lft mt-5"
            >
              <li class="">
                <a href="#"><span class="icon-twitter"></span></a>
              </li>
              <li class="">
                <a href="#"><span class="icon-facebook"></span></a>
              </li>
              <li class="">
                <a href="#"><span class="icon-instagram"></span></a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4 ml-md-5">
            <h2 class="ftco-heading-2">Information</h2>
            <ul class="list-unstyled">
              <li><a href="#" class="py-2 d-block">About</a></li>
              <li><a href="#" class="py-2 d-block">Services</a></li>
              <li><a href="#" class="py-2 d-block">Term and Conditions</a></li>
              <li><a href="#" class="py-2 d-block">Best Price Guarantee</a></li>
              <li>
                <a href="#" class="py-2 d-block"
                  >Privacy &amp; Cookies Policy</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Customer Support</h2>
            <ul class="list-unstyled">
              <li><a href="#" class="py-2 d-block">FAQ</a></li>
              <li><a href="#" class="py-2 d-block">Payment Option</a></li>
              <li><a href="#" class="py-2 d-block">Booking Tips</a></li>
              <li><a href="#" class="py-2 d-block">How it works</a></li>
              <li><a href="#" class="py-2 d-block">Contact Us</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md">
          <div class="ftco-footer-widget mb-4">
            <h2 class="ftco-heading-2">Have a Questions?</h2>
            <div class="block-23 mb-3">
              <ul>
                <li>
                  <span class="icon icon-map-marker"></span
                  ><span class="text"
                    >F2 Jesus Able House, Remera Kigali
                    RWANDA</span
                  >
                </li>
                <li>
                  <a href="#"
                    ><span class="icon icon-phone"></span
                    ><span class="text">0789 326 245</span></a
                  >
                </li>
                <li>
                  <a href="#"
                    ><span class="icon icon-envelope"></span
                    ><span class="text">info@yourdomain.com</span></a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p>
            <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
            Copyright &copy; 2025 All rights reserved | Kigali Car Rental Self Drive
            <i class="icon-heart color-danger" aria-hidden="true"></i> by
            <a href="#" target="_blank">Tamba Group</a>
            <!-- Link back to Colorlib can't be removed. Template is licensed under CC BY 3.0. -->
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<style>
.video-background {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.background-video {
  top: 0;
  left: 0;
  width: 230%;
  object-fit: cover; /* Ensures the video covers the entire container */
  z-index: -1; /* Places the video behind any content inside the div */
}
.video-background1 {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.background-video1 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the video covers the entire section */
  z-index: -1; /* Places the video behind other content */
}
</style>
